/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S15_HeadingInputs */

const tr_kullanim_s15_heading = /** @type {(inputs: Kullanim_S15_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15. İade ve İptal`)
};

const en_kullanim_s15_heading = /** @type {(inputs: Kullanim_S15_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15. Refund and cancellation`)
};

const de_kullanim_s15_heading = /** @type {(inputs: Kullanim_S15_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15. Rückerstattung und Stornierung`)
};

const ru_kullanim_s15_heading = /** @type {(inputs: Kullanim_S15_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15. Возврат и отмена`)
};

/**
* | output |
* | --- |
* | "15. Refund and cancellation" |
*
* @param {Kullanim_S15_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s15_heading = /** @type {((inputs?: Kullanim_S15_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S15_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s15_heading(inputs)
	if (locale === "de") return de_kullanim_s15_heading(inputs)
	if (locale === "ru") return ru_kullanim_s15_heading(inputs)
	return tr_kullanim_s15_heading(inputs)
});